module.exports = __webpack_public_path__ + "static/media/attendance-report-not-viewed.6345db45.svg";